import React from "react";
import { useParams } from "react-router-dom";
import GlobalAdditionInfo from "../../pages/common/globaladdinfo";
import Student12TopMenu from "../studentInfo/student12topmenu";
import PageNotes from "../../pages/common/pagenotesnew";
import { useAuth } from "../../../usercontext";

export default function InstructorStudentAddInfo() {
  let { slug } = useParams();
  const { profile, setProfile } = useAuth();

  return (
    <>
     <Student12TopMenu slug={slug} activeMenu={"AddInfo"} />  
      <PageNotes
        type={"Instructor"}
        pageName={"AddInfo"}
        studentId={slug}
        instructorId={profile.id}
      />
      <div className="tak-instruct-group">
        <div className="row">
          <div className="col-md-12">
            <GlobalAdditionInfo slug={slug} />
          </div>
        </div>
      </div>
    </>
  );
}
